import { render, staticRenderFns } from "./MarkAttendance.vue?vue&type=template&id=b310a28e&scoped=true&"
import script from "./MarkAttendance.vue?vue&type=script&lang=js&"
export * from "./MarkAttendance.vue?vue&type=script&lang=js&"
import style0 from "./MarkAttendance.vue?vue&type=style&index=0&id=b310a28e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b310a28e",
  null
  
)

export default component.exports